/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Environmental_TextureInputs */

const en_environmental_texture = /** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environmental Texture`)
};

const id_environmental_texture = /** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekstur Lingkungan`)
};

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const es_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const fr_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const de_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const ja_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const zh_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const ar_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const it_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const ru_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const pt_environmental_texture = en_environmental_texture;

/** @type {(inputs: Environmental_TextureInputs) => LocalizedString} */
const ko_environmental_texture = en_environmental_texture;

/**
* | output |
* | --- |
* | "Environmental Texture" |
*
* @param {Environmental_TextureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const environmental_texture = /** @type {((inputs?: Environmental_TextureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Environmental_TextureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_environmental_texture(inputs)
	if (locale === "es") return es_environmental_texture(inputs)
	if (locale === "fr") return fr_environmental_texture(inputs)
	if (locale === "de") return de_environmental_texture(inputs)
	if (locale === "ja") return ja_environmental_texture(inputs)
	if (locale === "zh") return zh_environmental_texture(inputs)
	if (locale === "ar") return ar_environmental_texture(inputs)
	if (locale === "id") return id_environmental_texture(inputs)
	if (locale === "it") return it_environmental_texture(inputs)
	if (locale === "ru") return ru_environmental_texture(inputs)
	if (locale === "pt") return pt_environmental_texture(inputs)
	return ko_environmental_texture(inputs)
});